import { apiService } from '@/src/services/api-service';
import {
  createCustomerClassificationUrl,
  createCustomerClassificationV2Url,
} from '../constants/endpoints';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

export interface CustomerClassificationQueryParams {
  ovoAccountId?: string;
  firstname?: string;
  lastname?: string;
  addressline1?: string;
  addressline2?: string;
  city?: string;
  email?: string;
  postcode?: string;
  phoneNumber?: string;
}

export type CustomerClassification = 'active' | 'inactive' | 'recent';

export interface CustomerClassificationResponse {
  classification: CustomerClassification;
}

export const useCustomerClassificationQuery = (
  props: CustomerClassificationQueryParams,
  options?: UseQueryOptions<CustomerClassificationResponse>,
): UseQueryResult<CustomerClassificationResponse> => {
  const { ovoAccountId } = props;
  const customerClassificationUrl = createCustomerClassificationUrl(props);

  return useQuery(
    `customer-classification-${ovoAccountId}`,
    () =>
      apiService.get<CustomerClassificationResponse>({
        url: customerClassificationUrl,
        headers: {
          'x-source': 'myovo',
        },
      }),
    {
      enabled: options?.enabled,
    },
  );
};

export type ProductSetCode =
  | 'BOILER_INSURANCE'
  | 'EV_SUBSCRIPTION'
  | 'BOILER_SERVICE'
  | 'EV_CHARGER_COVER'
  | 'ELECTRICS_PLUMBING_DRAINAGE';

export interface ProductSetClassification {
  code: ProductSetCode;
  status: CustomerClassification;
}

export interface CustomerClassificationV2Response {
  classification: ProductSetClassification[];
}

export const useCustomerClassificationV2Query = (
  props: CustomerClassificationQueryParams,
  options?: UseQueryOptions<CustomerClassificationV2Response>,
): UseQueryResult<CustomerClassificationV2Response> => {
  const { ovoAccountId } = props;
  const customerClassificationV2Url = createCustomerClassificationV2Url(props);

  return useQuery(
    `customer-classification-v2-${ovoAccountId}`,
    () =>
      apiService.get<CustomerClassificationV2Response>({
        url: customerClassificationV2Url,
        headers: {
          'x-source': 'myovo',
        },
      }),
    {
      enabled: options?.enabled,
    },
  );
};
